<script setup>

import {useStore} from "vue2-helpers/vuex";

const store = useStore();
defineProps(['report']);
</script>

<template>
    <div class="container">
        <div class="deep-report">
            <div class="deep-report__col">
                <h4>Switchpitch // {{ store.state.user.company_name }}</h4>

                <h2>01</h2>
            </div>
            <div class="deep-report__col">
                <h4>{{(new Date(report.created_at)).toLocaleString('en-US', { month: 'short', year: 'numeric' }).toUpperCase()}}</h4>

                <h2 class="mt-auto">{{ report.tracker_name }}</h2>
            </div>
        </div>
        <!-- <div class="deep-report" style="">
            <div style="font-size: 20px; text-transform: uppercase; color: #9a9a9a">
                <div style="float: left; width: 50%">
                    Switchpitch // {{ store.state.user.company_name }}
                </div>
                <div style="float: right; width: 50%; text-align: right">
                    {{(new Date(report.created_at)).toLocaleString('en-US', { month: 'short', year: 'numeric' }).toUpperCase()}}
                </div>
            </div>

            <div style="">
                <div style="float: left; width: 20%">
                    
                </div>

                <div style="float: right; width: 70%; text-align: right">
                    {{ report.tracker_name }}
                </div>
            </div>
        </div> -->
    </div>
</template>

<style scoped>
    .container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
        height: 94%;
    }
    @media (min-width: 640px) {
        .deep-report {
            display: flex;
            padding: 20px 0;
            height: 100%;
        }
    }
    .deep-report {
        padding: 20px;
        height: 100%;
        border-bottom: 5px solid #dfe8ee;
    }
    .deep-report__col {
        display: flex;
        flex-direction: column;
        margin-bottom: 10px;
        width: 100%;
    }
    @media (min-width: 640px) {
        .deep-report__col {
            margin-bottom: 0;
            width: 50%;
        }
        .deep-report__col:last-child {
            text-align: right;
        }
    }
    .deep-report h2 {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;  
        overflow: hidden;
        margin: 10px 0 0;
        width: 100%;
        font-weight: bold;
        font-size: 30px;
        text-transform: uppercase;
    }
    @media (min-width: 640px) {
        .deep-report h2 {
            font-size: 40px;
        }
    }
    .deep-report h4 {
        color: #9a9a9a;
        font-size: 20px; 
        text-transform: uppercase;
    }
</style>
